import {FC} from 'react'

import {TrustpilotWidgetVariant, useTrustpilotContent} from '@/content/trustpilot'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'
import {useMatchMedia} from '@/utils/ui/hooks/useMatchMedia'

import {Text, TextVariant} from '../common/content/Text'
import {Spinner} from '../Spinner'
import {TrustpilotWidget} from './TrustpilotWidget'

type TrustpilotCarouselProps = {
  isCentered?: boolean
}

export const TrustpilotCarousel: FC<React.PropsWithChildren<TrustpilotCarouselProps>> = ({
  isCentered = false,
}) => {
  const {t} = useTranslation()
  const {carouselTitle, trustpilotLinkHref, trustpilotSettings} = useTrustpilotContent(
    TrustpilotWidgetVariant.carousel,
  )
  const {trustpilotSettings: mobileTrustpilotSettings} = useTrustpilotContent(
    TrustpilotWidgetVariant.mobileCarousel,
  )
  const isMobile = useMatchMedia(MOBILE_SCREENSIZE)

  return (
    <>
      <div className="title">
        <Text variant={TextVariant.h2}>{t(carouselTitle)}</Text>
      </div>
      <div className="testimonial">
        {isMobile === null ? (
          <a href={trustpilotLinkHref} target="_blank" rel="noopener noreferrer">
            <Spinner color={theme.palette.text.default} />
          </a>
        ) : (
          <TrustpilotWidget
            key={isMobile ? 'mobile' : 'desktop'}
            variant={
              isMobile ? TrustpilotWidgetVariant.mobileCarousel : TrustpilotWidgetVariant.carousel
            }
          />
        )}
      </div>

      <style jsx>{`
        .title {
          text-align: ${isCentered ? 'center' : 'left'};
        }
        .testimonial {
          min-height: ${trustpilotSettings.height};
          margin-left: -${theme.spacing[3]};
          margin-top: ${theme.spacing[8]};
        }
        @media ${TABLET_SCREENSIZE} {
          .title {
            text-align: center;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .testimonial {
            min-height: ${mobileTrustpilotSettings.height};
            margin-left: 0;
            margin-top: ${theme.spacing[6]};
          }
        }
      `}</style>
    </>
  )
}
